import { DateTime } from 'luxon';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Td } from '@/components/Table';
import Text from '@/components/Text';
import { Dispatch } from '@/utils/store';

const Tr = styled.tr`
  cursor: pointer;
  transition: background-color ease-out 0.2s;
  td {
    transition: background-color ease-out 0.2s;
  }
  &:hover {
    td {
      background-color: ${({ theme }) =>
        theme.colors.grayscaleExtraLight} !important;
    }
  }
`;

const TextWrapper = styled.div`
  max-width: 360px;
`;

interface Props {
  article: {
    title: string;
    slug: string;
    id: number;
    date_created: number;
    author_email: string;
    author_name: string;
    is_open_list: boolean;
  };
}

const CoverImagesNewTableRow: FC<Props> = ({ article }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch<Dispatch>();

  const handleRowClick = () => {
    dispatch.coverImages.setNewArticle({
      title: article.title,
      slug: article.slug,
      id: article.id,
      date_created: DateTime.fromSeconds(article.date_created, {
        zone: 'UTC',
      }).toISO(),
      editor: article.author_email,
      is_open_list: article.is_open_list,
    });
    navigate('/general/cover-images/generate/one');
  };

  return (
    <Tr onClick={() => handleRowClick()}>
      <Td>
        <TextWrapper>{article.title}</TextWrapper>
      </Td>
      <Td>
        {DateTime.fromSeconds(article.date_created, {
          zone: 'UTC',
        })
          .setZone('local', { keepLocalTime: true })
          .toRelative({})}
        <br />
        <Text $type="extraSmall" $color="gray" as="span">
          {DateTime.fromSeconds(article.date_created, {
            zone: 'UTC',
          }).toFormat('HH:mm')}
        </Text>
      </Td>
      <Td>{article.author_name ?? '-'}</Td>
      <Td>{article.is_open_list ? 'True' : 'False'}</Td>
    </Tr>
  );
};

export default CoverImagesNewTableRow;
